export default __webpack_public_path__ + "static/media/le_lion13.2d3e4b9f.jpg";